import { clsx } from 'clsx';

interface ScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md';
}

function getScoreColor(score: number) {
  if (score >= 4) return 'bg-green-100 text-green-800';
  if (score >= 3) return 'bg-yellow-100 text-yellow-800';
  if (score >= 2) return 'bg-orange-100 text-orange-800';
  return 'bg-red-100 text-red-800';
}

export function ScoreBadge({ score, size = 'sm' }: ScoreBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-full font-medium',
        getScoreColor(score),
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      )}
    >
      {score.toFixed(1)}
    </span>
  );
}
